import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import CssBaseline from '@mui/material/CssBaseline';

import App from './App';
import { setNavigateCallback, setAuthAtomUpdateCallback } from '@/apis/api';
import { authAtom } from '@/atom/authAtom';
import GlobalStyle from '@/styles/global-styles';

const queryClient = new QueryClient();

// Axios 설정을 위한 래퍼 컴포넌트
const AppWithAxios = () => {
  const navigate = useNavigate();
  const setAuthAtom = useSetAtom(authAtom);
  
  React.useEffect(() => {
    setNavigateCallback(navigate);
    setAuthAtomUpdateCallback(setAuthAtom);
  }, [navigate, setAuthAtom]);
  
  return <App />;
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <GlobalStyle />
        <CssBaseline />
        <AppWithAxios />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
